import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { setAuthSuccessRedirect } from '@utils/authSuccessRedirect';
import { useUserContext } from '../../contexts/user-context';
import {
  SORTING_HAT,
  SORTING_HAT_FIRST_QUESTION,
  NEXT_PATRONUS,
  LOGIN,
  PROFILE,
} from '../../constants/routes';
import { HOGWARTS_HOUSES } from '../../constants';

const useProfileRouter = (profilePath) => {
  const router = useRouter();

  const { loadingProfile, isLoggedIn, profile } = useUserContext();
  const isSortingOutcomePath = HOGWARTS_HOUSES.includes(profilePath);
  const isLegacySortingIntro = profilePath === 'sorting-intro';

  useEffect(() => {
    if (loadingProfile) return;

    // Anon users are sent to login if not going to sorting outcome/intro
    if (!loadingProfile && !isLoggedIn) {
      if (isLegacySortingIntro) {
        router.replace(SORTING_HAT);
      } else if (isSortingOutcomePath) {
        setAuthSuccessRedirect(SORTING_HAT_FIRST_QUESTION);
        router.replace(SORTING_HAT);
      } else {
        setAuthSuccessRedirect(`${window.location.pathname}${window.location.search || ''}`);
        router.replace(LOGIN);
      }
    }

    // Users with a house are always redirected from outcome/intro to their own
    // house outcome page. Users with no house trying to go to outcome pages
    // get sent to intro.
    if (profile.hogwartsHouse) {
      if (isSortingOutcomePath || isLegacySortingIntro) {
        const userHouse = profile.hogwartsHouse.toLowerCase();

        // Prevent an infinite redirect if user is already going to their own house outcome
        if (userHouse !== profilePath) {
          router.replace(`${PROFILE}/${userHouse}`);
        }
      }
    } else if (!profile.hogwartsHouse && isSortingOutcomePath) {
      router.replace(PROFILE);
    } else if (!profile.hogwartsHouse && isLegacySortingIntro && isLoggedIn) {
      router.replace(SORTING_HAT);
    }

    if (profilePath === 'wand' && !profile.wand) {
      router.replace(PROFILE);
    } else if (profilePath === 'patronus' && !profile.patronusName) {
      router.replace(NEXT_PATRONUS);
    }
  }, [
    isLoggedIn,
    profile,
    loadingProfile,
    isSortingOutcomePath,
    profilePath,
    router,
    isLegacySortingIntro,
  ]);

  return {};
};

export default useProfileRouter;
